module.exports = __webpack_public_path__ + "e625c16e4d2009bcaac188aa865030ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_gold_large.svg
// module id = 980
// module chunks = 0